import { tv } from 'tailwind-variants'

export const styles = tv({
  slots: {
    container: 'p-2.5',
  },
})
